import axios from "axios";
import { IPublicClientApplication } from "@azure/msal-browser";
import { apiRequest } from "../authConfig";

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api`;

export interface InventoryItemDto {
  inventoryId: string | null;
  inventoryDesc: string | null;
  uom: string | null;
}

export interface UpsertInventoryItemRequest {
  inventoryId: string | null;
  inventoryDesc: string | null;
  uom: string | null;
}

const auth = async (instance: IPublicClientApplication, account: any) => {
  const response = await instance.acquireTokenSilent({ ...apiRequest, account });
  return { headers: { Authorization: `Bearer ${response.accessToken}` } };
};

export const getInventoryItems = async (instance: IPublicClientApplication, account: any): Promise<InventoryItemDto[]> => {
  const config = await auth(instance, account);
  const res = await axios.get<InventoryItemDto[]>(`${API_URL}/inventoryitem`, config);
  return res.data;
};

export const createInventoryItem = async (instance: IPublicClientApplication, account: any, body: UpsertInventoryItemRequest) => {
  const config = await auth(instance, account);
  const res = await axios.post<InventoryItemDto>(`${API_URL}/inventoryitem`, body, config);
  return res.data;
};

export const updateInventoryItem = async (instance: IPublicClientApplication, account: any, inventoryId: string, body: UpsertInventoryItemRequest) => {
  const config = await auth(instance, account);
  const res = await axios.put<InventoryItemDto>(`${API_URL}/inventoryitem/${inventoryId}`, body, config);
  return res.data;
};

export const deleteInventoryItem = async (instance: IPublicClientApplication, account: any, inventoryId: string) => {
  const config = await auth(instance, account);
  await axios.delete(`${API_URL}/inventoryitem/${inventoryId}`, config);
};
